// extracted by mini-css-extract-plugin
export default {"container":"empty-page_container__7k3et","label":"empty-page_label__rM+St","heading":"empty-page_heading__T-oKm","description":"empty-page_description__JP0Px"};